module.exports = "/_next/static/images/Key-35c4d8ff92371fb2f9d84fa31190606c.png";